import React from 'react';
import { Outlet } from 'react-router-dom';
import { MY_LEARNING_PATH, SUBSCRIBER_PATH } from '../../../../constants';
import { useActiveProduct } from '../../../../helpers/customHook';

const MyLearning = React.lazy(() => import('./index'));
const CourseGroupCategory = React.lazy(() => import('./CourseGroupCategory'));
const MyProfessional = React.lazy(() => import('../MyProfessionals'));
const Lessons = React.lazy(() => import('./Lessons'));
const TakeSurvey = React.lazy(() => import('../TakeSurvey'));
const TakeTest = React.lazy(() => import('../TakeTest'));
const TrainingEventDetails = React.lazy(() => import('./Trainings/TrainingEventDetails'));
const TrainingProductDetails = React.lazy(() => import('./Trainings/TrainingProductDetails'));
const MyAccountSettings = React.lazy(() => import('../AccountSettings/MyAccountSettings'));
const MyPurchases = React.lazy(() => import('../Purchases'));
const Organizations = React.lazy(() => import('../MyOrganizations'));

const GetCourseProductName = ({ match }) => {
     const product = useActiveProduct();

     if (product) return <span>{product?.publishName || '...'}</span>;

     return '...';
};

const GetCourseProductNameEvent = ({ match }) => {
     const slug = match.params.slug;
     const product = useActiveProduct();

     if (product) {
          return <span>{product?.publishName} Event</span>;
     }

     return slug + 'Event';
};

const Routes = {
     path: MY_LEARNING_PATH.DASHBOARD,
     breadcrumb: 'Learning Center',
     element: <Outlet />,
     children: [
          { index: true, element: <MyLearning /> },
          {
               path: SUBSCRIBER_PATH.MY_ACCOUNT_SETTINGS,
               breadcrumb: 'My Account Settings',
               element: <MyAccountSettings />,
          },
          {
               path: SUBSCRIBER_PATH.MY_PURCHASES,
               breadcrumb: 'My Purchases',
               element: <MyPurchases />,
          },
          {
               path: SUBSCRIBER_PATH.ORGANIZATION,
               breadcrumb: 'My Organization',
               element: <Organizations />,
          },
          {
               path: SUBSCRIBER_PATH.MY_PROFESSIONAL_DETAIL,
               breadcrumb: 'Professional Details',
               element: <Outlet />,
               children: [
                    {
                         index: true,
                         element: <MyProfessional />,
                    },
               ],
          },
          {
               path: SUBSCRIBER_PATH.MY_TRAINING,
               breadcrumb: 'My Training',
               element: <Outlet />,
               children: [
                    { index: true, element: <CourseGroupCategory /> },
                    {
                         path: SUBSCRIBER_PATH.COURSE_PRODUCT_DETAILS,
                         breadcrumb: GetCourseProductName,
                         element: <Outlet />,
                         children: [
                              { index: true, element: <TrainingProductDetails /> },
                              {
                                   path: SUBSCRIBER_PATH.COURSE_EVENT_DETAILS,
                                   breadcrumb: GetCourseProductNameEvent,
                                   element: <Outlet />,
                                   children: [
                                        { index: true, element: <TrainingEventDetails /> },
                                        {
                                             path: SUBSCRIBER_PATH.TAKE_TEST_TRAINING,
                                             breadcrumb: 'Test',
                                             element: <TakeTest />,
                                        },
                                        {
                                             path: SUBSCRIBER_PATH.TAKE_SURVEY_TRAINING,
                                             breadcrumb: 'Survey',
                                             element: <TakeSurvey />,
                                        },
                                   ],
                              },
                         ],
                    },
                    {
                         path: SUBSCRIBER_PATH.COURSE_CATEGORIES_DETAILS_LESSONS,
                         breadcrumb: 'Course',
                         element: <Lessons />,
                    },
                    {
                         path: SUBSCRIBER_PATH.TAKE_SURVEY,
                         breadcrumb: 'Survey',
                         element: <TakeSurvey />,
                    },
                    {
                         path: SUBSCRIBER_PATH.TAKE_TEST,
                         breadcrumb: 'Test',
                         element: <TakeTest />,
                    },
               ],
          },
     ],
};

export default Routes;
